import { Component, AfterViewInit, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig,
} from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";

import swal from "sweetalert";
import { MasterService } from "src/app/data-service/master-service";
declare var $: any;

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.css"],
})
export class NavigationComponent implements AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  public config: PerfectScrollbarConfigInterface = {};

  public showSearch = false;
  loggedInUserName: string;
  loggedInUser: string;
  branch: string;
  userRole: string;
  lastLogin: string;
  userDataDtoReturnSession: any;
  isLoggedIn = true;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private masterService: MasterService
  ) {
    //Commented for login page Seesion swal issue on 20012024

    // if (sessionStorage.length == 0) {
    //   this.isLoggedIn = false;
    //   swal({
    //     title: "Session Expired",
    //     text: "Please relogin to access the application!",
    //     icon: "error",
    //     closeOnClickOutside: false,
    //     closeOnEsc: false,
    //   }).then(() => {
    //     this.logInPage();
    //   })
    // }
    if (sessionStorage.length == 0) {
      this.isLoggedIn = false;
    }

    if (this.isLoggedIn) {
      this.userDataDtoReturnSession = JSON.parse(
        sessionStorage.getItem("HRWeb")
      );
      console.log("this.userDataDtoReturnSession");
      console.log(this.userDataDtoReturnSession);
      let userNameObj = sessionStorage.getItem("userName");
      
      this.loggedInUserName =
        userNameObj == null ? null : userNameObj.toUpperCase();
      this.loggedInUser = this.userDataDtoReturnSession.loginId;
      this.userRole = this.userDataDtoReturnSession.role;
      this.branch = this.userDataDtoReturnSession.locationName;
      this.lastLogin = this.userDataDtoReturnSession.lastLoginStr;
      
    }
  }

  // This is for Notifications
  notifications: Object[] = [
    {
      btn: "btn-danger",
      icon: "ti-link",
      title: "Luanch Admin",
      subject: "Just see the my new admin!",
      time: "9:30 AM",
    },
    {
      btn: "btn-success",
      icon: "ti-calendar",
      title: "Event today",
      subject: "Just a reminder that you have event",
      time: "9:10 AM",
    },
    {
      btn: "btn-info",
      icon: "ti-settings",
      title: "Settings",
      subject: "You can customize this template as you want",
      time: "9:08 AM",
    },
    {
      btn: "btn-primary",
      icon: "ti-user",
      title: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:00 AM",
    },
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: "assets/images/users/1.jpg",
      status: "online",
      from: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:30 AM",
    },
    {
      useravatar: "assets/images/users/2.jpg",
      status: "busy",
      from: "Sonu Nigam",
      subject: "I have sung a song! See you at",
      time: "9:10 AM",
    },
    {
      useravatar: "assets/images/users/2.jpg",
      status: "away",
      from: "Arijit Sinh",
      subject: "I am a singer!",
      time: "9:08 AM",
    },
    {
      useravatar: "assets/images/users/4.jpg",
      status: "offline",
      from: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:00 AM",
    },
  ];

  ngAfterViewInit() {}

  logOut() {
    sessionStorage.clear();
    this.router.navigate(["/authentication/login2"]);
  }

  logInPage() {
    this.router.navigate(["/authentication/login2"]);
  }
}
